import { createSlice } from "@reduxjs/toolkit";

export const occActions = createSlice({
  name: "occFiles",
  initialState: {
    value: {
      OCCFiles: [],
      EquipModels: [],
    },
  },
  
  reducers: {
       
    updateOCCFiles(state, { payload }) {
      console.log("Occ files " + state.value.OCCFiles.length);
      state.value.OCCFiles = payload;
    },

    updateEquipModel(state, { payload }) {
      console.log("Equip models " + state.value.EquipModels.length);
      state.value.EquipModels.push(payload);
    },


  },
});

export const {
  updateOCCFiles,
  updateEquipModel,
} = occActions.actions;

export default occActions.reducer;
